import { UserManager, Log } from 'oidc-client-ts';
import isBrowser from '@util/isBrowser';
import { oidcSettings } from './oidcSettings';
/* eslint-disable */
///////////////////////////////
// config
///////////////////////////////
Log.setLogger(console);
Log.setLevel(Log.WARN);

function log() {
  return;
}

export const mgr = isBrowser ? new UserManager(oidcSettings) : { events: {} };

///////////////////////////////
// cross-tab sign-out sync
///////////////////////////////
//* userStore is per-tab sessionStorage (oidc-client-ts default, unchanged), so
//* signing out in one tab doesn't touch another tab's copy of the user. Rather
//* than moving tokens into shared localStorage to get that sync, broadcast a
//* plain signal and let each tab drop its own token.
const AUTH_SYNC_CHANNEL = 'bmo-auth-sync';
const authChannel =
  isBrowser && typeof BroadcastChannel !== 'undefined'
    ? new BroadcastChannel(AUTH_SYNC_CHANNEL)
    : null;

//* lets AuthProvider distinguish "this tab was told to sign out by another
//* tab" from every other removeUser() cause (expiry, renew failure, etc.), so
//* it can show a message only for the cross-tab case
const crossTabSignOutListeners = new Set();
export function onCrossTabSignOut(cb) {
  crossTabSignOutListeners.add(cb);
  return function unsubscribe() {
    crossTabSignOutListeners.delete(cb);
  };
}

if (authChannel) {
  authChannel.onmessage = function (e) {
    if (e.data === 'signed-out') {
      mgr.removeUser().catch(function (err) {
        log(err);
      });
      crossTabSignOutListeners.forEach(function (cb) {
        cb();
      });
    }
  };
}

///////////////////////////////
// events
///////////////////////////////
// mgr.events.addAccessTokenExpiring(function() {
//   console.log('token expiring');
//   log('token expiring');
// });
if (isBrowser) {
  //* with monitorSession off, an SSO logout elsewhere is detected when token
  //* renewal fails: drop the local user instead of showing a stale session
  mgr.events.addAccessTokenExpired(function () {
    console.log('token expired');
    mgr.removeUser().catch(function (err) {
      log(err);
    });
  });

  mgr.events.addSilentRenewError(function (e) {
    console.log('silent renew error', e.message);
    const sessionGoneErrors = [
      'invalid_grant',
      'login_required',
      'interaction_required',
      'access_denied',
    ];
    if (sessionGoneErrors.includes(e?.error)) {
      mgr.removeUser().catch(function (err) {
        log(err);
      });
    }
  });

  // mgr.events.addUserLoaded(function(user) {
  //   console.log("user loaded", user)
  //   mgr.getUser().then(function() {
  //     console.log("getUser loaded user after userLoaded event fired")
  //   })
  // })

  mgr.events.addUserUnloaded(function (e) {
    console.log('user unloaded');
  });

  //* dead while monitorSession is false; must stay a local removeUser — a
  //* signoutRedirect() here reintroduces the Safari/Incognito forced-logout
  //* loop if monitoring is ever re-enabled
  mgr.events.addUserSignedOut(function () {
    clearState();
    mgr.removeUser().catch(function (err) {
      log(err);
    });
  });
}

///////////////////////////////
// functions for UI elements
///////////////////////////////
function clearState() {
  //* reset the per-tab silent-signin guard so the next visit can attempt iframe SSO again
  if (isBrowser) sessionStorage.removeItem('silentSigninAttempted');

  mgr
    .clearStaleState()
    .then(function () {
      log('clearStateState success');
    })
    .catch(function (e) {
      log('clearStateState error', e.message);
    });
}

// function getUser() {
//   return mgr
//     .getUser()
//     .then(function(user) {
//       log('got user', user);
//       return user;
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }

// function removeUser() {
//   mgr
//     .removeUser()
//     .then(function() {
//       log('user removed');
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }

export function startSigninMainWindow(returnPath) {
  //* capture where the user was before the SSO round-trip so /authredirect/
  //* can send them back — otherwise every redirect lands on "/" and drops
  //* whatever flow (e.g. subscribe/create) they were in the middle of.
  //* callers can override (e.g. /login itself shouldn't send users back to /login).
  const resolvedReturnPath =
    returnPath ??
    window.location.pathname + window.location.search + window.location.hash;
  mgr
    .signinRedirect({ state: { returnPath: resolvedReturnPath } })
    .then(function () {
      log('signinRedirect done');
    })
    .catch(function (err) {
      log(err);
    });
}

// function endSigninMainWindow() {
//   mgr
//     .signinRedirectCallback()
//     .then(function(user) {
//       log('signed in', user);
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }

// function startSigninMainWindowDiffCallbackPage() {
//   mgr
//     .signinRedirect({
//       state: 'some data',
//       redirect_uri: 'http://localhost:8000/identityserver-sample-callback.html',
//     })
//     .then(function() {
//       log('signinRedirect done');
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }

let inFlightSilent = null;
export function iframeSignin() {
  if (inFlightSilent) return inFlightSilent;
  inFlightSilent = mgr
    .signinSilent()
    .then((user) => user ?? null)
    .catch((err) => {
      console.warn('signinSilent failed:', err);
      return null;
    })
    .finally(() => {
      inFlightSilent = null;
    });
  return inFlightSilent;
}

// function querySessionStatus() {
//   mgr
//     .querySessionStatus()
//     .then(function(status) {
//       log("user's session status", status);
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }

export function startSignoutMainWindow() {
  //   mgr
  //     .signoutRedirect()
  //     .then(function(resp) {
  authChannel?.postMessage('signed-out');
  mgr
    .signoutRedirect()
    .then(function (resp) {
      clearState();
      console.log('signed out', resp);
    })
    .catch(function (err) {
      log(err);
    });
}

// function endSignoutMainWindow() {
//   mgr
//     .signoutRedirectCallback()
//     .then(function(resp) {
//       log('signed out', resp);
//     })
//     .catch(function(err) {
//       log(err);
//     });
// }
